/* ── Root ──────────────────────────────────────────────────── */
.root { display: flex; flex-direction: column; gap: var(--sp-8); }

.header { }
.title { font-family: var(--font-mono); font-size: 22px; font-weight: 700; letter-spacing: 0.5px; }
.sub   { font-size: 13px; color: var(--color-text-muted); margin-top: var(--sp-1); }

/* ── Tabs ──────────────────────────────────────────────────── */
.tabBar {
  display: flex;
  gap: var(--sp-2);
  margin-bottom: var(--sp-6);
}

.tabBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-2) var(--sp-4);
  border-radius: 999px;
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.tabBtn:hover {
  border-color: var(--color-border-med);
  color: var(--color-text);
}

.tabBtnActive {
  background: rgba(56, 189, 248, 0.1);
  border-color: rgba(56, 189, 248, 0.3);
  color: var(--color-sky);
}

.tabContent {
  min-height: 400px;
}

/* ── Two-column grid ───────────────────────────────────────── */
.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--sp-6);
}

@media (max-width: 900px) { .grid { grid-template-columns: 1fr; } }

/* ── Section ───────────────────────────────────────────────── */
.section { display: flex; flex-direction: column; gap: var(--sp-4); }

.sectionHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sectionLabel {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  color: var(--color-text-muted);
  text-transform: uppercase;
}

.layerTag {
  font-family: var(--font-mono);
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: var(--color-sky);
  letter-spacing: 1.5px;
}

/* ── Field list card ───────────────────────────────────────── */
.fieldList {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--sp-4) var(--sp-5);
  border-bottom: 1px solid var(--color-border);
  gap: var(--sp-4);
}

.field:last-child { border-bottom: none; }

.fieldLabel {
  font-size: 13px;
  color: var(--color-text-muted);
  white-space: nowrap;
}

.fieldValue {
  font-size: 13px;
  color: var(--color-text);
  text-align: right;
  display: flex;
  align-items: center;
  gap: var(--sp-2);
}

.fieldValue.mono  { font-family: var(--font-mono); font-size: 12px; }
.fieldValue.small { font-size: 11px; word-break: break-all; max-width: 240px; }
.fieldValue.accent { color: var(--color-sky); font-weight: 600; }
.fieldValue.ok    { color: var(--color-success); }
.fieldValue.muted2 { color: var(--color-text-faint); }

/* ── Storage progress bar ──────────────────────────────────── */
.storageBarTrack {
  width: 160px;
  height: 4px;
  background: var(--color-border);
  border-radius: 2px;
  overflow: hidden;
}

.storageBarFill {
  height: 100%;
  background: rgba(56, 189, 248, 0.5);
  border-radius: 2px;
}

/* ── Tables ────────────────────────────────────────────────── */
.table {
  width: 100%;
  border-collapse: collapse;
}

.tableInCard {
  /* inherits fieldList border from parent wrapper */
}

.th {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text-muted);
  text-align: left;
  padding: var(--sp-3) var(--sp-4);
  border-bottom: 1px solid var(--color-border);
  white-space: nowrap;
}

.tr { }

.tr:last-child .td { border-bottom: none; }

.td {
  padding: var(--sp-3) var(--sp-4);
  border-bottom: 1px solid var(--color-border);
  font-size: 13px;
  color: var(--color-text);
  vertical-align: middle;
}

/* ── Avatar ────────────────────────────────────────────────── */
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(56, 189, 248, 0.12);
  border: 1px solid rgba(56, 189, 248, 0.2);
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-sky);
  flex-shrink: 0;
  user-select: none;
}

/* ── User cell ─────────────────────────────────────────────── */
.userCell {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.userName  { font-size: 13px; font-weight: 500; color: var(--color-text); }
.userEmail { font-size: 11px; color: var(--color-text-faint); margin-top: 1px; font-family: var(--font-mono); }
.lastActive { font-size: 12px; color: var(--color-text-muted); font-family: var(--font-mono); }
.numCell    { font-family: var(--font-mono); font-size: 13px; color: var(--color-text); }

/* ── Status badges ─────────────────────────────────────────── */
.badge {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 2px 7px;
  border-radius: 999px;
  text-transform: uppercase;
  white-space: nowrap;
}

.badgeActive      { background: rgba(34, 197, 94, 0.12);  border: 1px solid rgba(34, 197, 94, 0.25);  color: var(--color-success); }
.badgeInvited     { background: rgba(234, 179, 8, 0.12);  border: 1px solid rgba(234, 179, 8, 0.25);  color: var(--color-warn); }
.badgeDeactivated { background: rgba(255,255,255, 0.04);  border: 1px solid var(--color-border);       color: var(--color-text-faint); }

/* ── Role select (Users tab) ───────────────────────────────── */
.roleSelect {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text);
  background: transparent;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: 3px 6px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
}

.roleSelect:focus { border-color: rgba(56, 189, 248, 0.4); color: var(--color-sky); }

.roleText {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text-muted);
}

/* ── Invite bar ────────────────────────────────────────────── */
.inviteBar {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-4) var(--sp-5);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  margin-bottom: var(--sp-5);
}

.inviteInput {
  flex: 1;
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-2) var(--sp-3);
  font-size: 13px;
  color: var(--color-text);
  outline: none;
  transition: border-color 0.15s;
}

.inviteInput::placeholder { color: var(--color-text-faint); }
.inviteInput:focus { border-color: rgba(56, 189, 248, 0.4); }
.inputError { border-color: rgba(239, 68, 68, 0.5) !important; }
.inviteErrorMsg { margin-top: 6px; font-size: 12px; color: rgba(239, 68, 68, 0.85); padding-left: 2px; }

.inviteSelect {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text);
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-2) var(--sp-3);
  cursor: pointer;
  outline: none;
}

.inviteBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-2) var(--sp-4);
  border-radius: var(--radius-md);
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.25);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}

.inviteBtn:hover { background: rgba(56, 189, 248, 0.18); }

/* ── Deactivate / Activate buttons ────────────────────────── */
.deactivateBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: var(--color-error);
  cursor: pointer;
  transition: background 0.15s;
}

.deactivateBtn:hover { background: rgba(239, 68, 68, 0.08); }

.activateBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid rgba(34, 197, 94, 0.2);
  color: var(--color-success);
  cursor: pointer;
  transition: background 0.15s;
}

.activateBtn:hover { background: rgba(34, 197, 94, 0.08); }

.actionBtns { display: flex; gap: 6px; align-items: center; }

.deleteUserBtn {
  font-size: 11px; font-weight: 500; padding: 3px 8px; border-radius: 4px;
  border: 1px solid rgba(239, 68, 68, 0.3); color: rgba(239, 68, 68, 0.7);
  background: transparent; cursor: pointer; transition: background 0.15s, color 0.15s;
}
.deleteUserBtn:hover { background: rgba(239, 68, 68, 0.08); color: rgba(239, 68, 68, 0.9); }

/* ── Usage tab ─────────────────────────────────────────────── */
.usageRoot { display: flex; flex-direction: column; gap: var(--sp-6); }

.monthBar { display: flex; gap: var(--sp-2); }

.monthPill {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-2) var(--sp-4);
  border-radius: 999px;
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.monthPill:hover { border-color: var(--color-border-med); color: var(--color-text); }

.monthPillActive {
  background: rgba(56, 189, 248, 0.1);
  border-color: rgba(56, 189, 248, 0.3);
  color: var(--color-sky);
}

/* ── Stat strip ────────────────────────────────────────────── */
.statStrip {
  display: flex;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.statBox {
  flex: 1;
  padding: var(--sp-5) var(--sp-6);
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
}

.statBoxDivider { border-left: 1px solid var(--color-border); }

.statValue {
  font-family: var(--font-mono);
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text);
}

.statLabel {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

/* ── Budget bar ────────────────────────────────────────────── */
.budgetBar {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--sp-4) var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.budgetLabel {
  display: flex;
  justify-content: space-between;
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text-muted);
}

.budgetTrack {
  height: 8px;
  border-radius: 4px;
  background: var(--color-border);
  overflow: hidden;
}

.budgetFill {
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(56, 189, 248, 0.7), rgba(13, 148, 136, 0.7));
  transition: width 0.3s ease;
}

/* ── Usage bar per row ─────────────────────────────────────── */
.usageBarTrack {
  width: 120px;
  height: 6px;
  background: var(--color-border);
  border-radius: 3px;
  overflow: hidden;
}

.usageBarFill {
  height: 100%;
  background: rgba(56, 189, 248, 0.5);
  border-radius: 3px;
  transition: width 0.3s ease;
}

/* ── Security tab ──────────────────────────────────────────── */
.securityRoot { display: flex; flex-direction: column; }

.enterpriseBadge {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 3px;
  background: rgba(226, 239, 248, 0.05);
  border: 1px solid var(--color-border);
  color: var(--color-text-faint);
  white-space: nowrap;
}

/* ── API Key table ─────────────────────────────────────────── */
.keyName {
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text);
}

.keyMask {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text-muted);
  margin-right: var(--sp-2);
  letter-spacing: 1px;
}

.copyBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.08);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s;
}

.copyBtn:hover { background: rgba(56, 189, 248, 0.16); }

.revokeBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: var(--color-error);
  cursor: pointer;
  transition: background 0.15s;
}

.revokeBtn:hover { background: rgba(239, 68, 68, 0.08); }

.revokedText {
  font-family: var(--font-mono);
  font-size: 11px;
  color: rgba(239, 68, 68, 0.5);
}

.generateBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-2) var(--sp-4);
  border-radius: var(--radius-md);
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.25);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}

.generateBtn:hover { background: rgba(56, 189, 248, 0.18); }

/* ── Data Governance rows ──────────────────────────────────── */
.govRow {
  display: grid;
  grid-template-columns: 200px 1fr auto;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-4) var(--sp-5);
  border-bottom: 1px solid var(--color-border);
}

.govRowLast { border-bottom: none; }

.govLabel {
  font-size: 13px;
  color: var(--color-text-muted);
  white-space: nowrap;
}

.govValue {
  font-size: 13px;
  color: var(--color-text);
}

.govValue.ok { color: var(--color-success); }

.ok { color: var(--color-success); }

.govBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.govBtn:hover { background: rgba(56, 189, 248, 0.08); border-color: rgba(56, 189, 248, 0.3); }

/* ── Danger Zone ───────────────────────────────────────────── */
.dangerZone {
  background: var(--color-surface);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: var(--radius-lg);
  padding: var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

.dangerLabel {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--color-error);
}

.dangerRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-6);
}

.dangerAction {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: var(--sp-1);
}

.dangerDesc { font-size: 12px; color: var(--color-text-muted); }

.dangerBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-3) var(--sp-5);
  border-radius: var(--radius-md);
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.25);
  color: var(--color-error);
  transition: background 0.15s;
  cursor: pointer;
  white-space: nowrap;
}

.dangerBtn:hover { background: rgba(239, 68, 68, 0.18); }

/* ── Business Profile tab ──────────────────────────────────── */
.profileTab { display: flex; flex-direction: column; gap: var(--sp-6); }

.profileHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sp-6);
}

.profileTitle {
  font-family: var(--font-mono);
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text);
}

.profileSub {
  font-size: 13px;
  color: var(--color-text-muted);
  margin-top: var(--sp-1);
  max-width: 480px;
  line-height: 1.6;
}

.profileCard {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.profileCardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--sp-4) var(--sp-5);
  border-bottom: 1px solid var(--color-border);
}

.profileContext {
  font-size: 14px;
  color: var(--color-text);
  line-height: 1.7;
  padding: var(--sp-5);
  margin: 0;
}

.profileEditBlock {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  padding: var(--sp-4) var(--sp-5);
}

.profileTextarea {
  width: 100%;
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-3) var(--sp-4);
  font-size: 14px;
  color: var(--color-text);
  line-height: 1.7;
  resize: vertical;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.profileTextarea:focus { border-color: rgba(56, 189, 248, 0.4); }

.profileEditActions {
  display: flex;
  justify-content: flex-end;
  gap: var(--sp-2);
}

.profileMeta {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  padding: var(--sp-3) var(--sp-5);
  border-top: 1px solid var(--color-border);
}

.profileMetaItem {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-faint);
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
}

.profileChips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-3) var(--sp-5);
  border-top: 1px solid var(--color-border);
}

.profileChipLabel {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--color-text-muted);
  margin-right: var(--sp-1);
}

.profileChip {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 999px;
  background: rgba(56, 189, 248, 0.08);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: var(--color-sky);
  text-transform: capitalize;
}

.profileChipTeal {
  background: rgba(13, 148, 136, 0.1);
  border-color: rgba(13, 148, 136, 0.25);
  color: #2dd4bf;
}

.profileEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sp-4);
  padding: var(--sp-12, 64px) var(--sp-6);
  background: var(--color-surface);
  border: 1px dashed var(--color-border);
  border-radius: var(--radius-lg);
  text-align: center;
}

.profileEmptyIcon {
  font-size: 32px;
  color: rgba(56, 189, 248, 0.3);
}

.profileEmptyTitle {
  font-family: var(--font-mono);
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text);
}

.profileEmptySub {
  font-size: 13px;
  color: var(--color-text-muted);
  max-width: 380px;
  line-height: 1.6;
}

/* ── Appearance tab ──────────────────────────────────────── */
.themeToggle {
  display: flex;
  gap: var(--sp-2);
}

.themeOption {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-2) var(--sp-5);
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}
.themeOption:hover {
  border-color: var(--color-border-med);
  color: var(--color-text);
}
.themeOptionActive {
  background: rgba(56, 189, 248, 0.1);
  border-color: rgba(56, 189, 248, 0.3);
  color: var(--color-sky);
}
[data-theme="light"] .themeOptionActive {
  background: rgba(3, 105, 161, 0.08);
  border-color: rgba(3, 105, 161, 0.3);
}

.themeSwatch {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid rgba(0,0,0,0.15);
}
.themeSwatch[data-swatch="dark"]  { background: #040D18; }
.themeSwatch[data-swatch="light"] { background: #F0F6FB; border-color: rgba(14,116,144,0.3); }

.emptyState {
  padding: var(--sp-8) var(--sp-4);
  text-align: center;
  color: var(--color-text-faint);
  font-size: 13px;
}

/* ── Usage tab ─────────────────────────────────────────────── */
.usageTab { display: flex; flex-direction: column; gap: var(--sp-6); }

.usageCard {
  padding: var(--sp-4);
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}
.usageHeader {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: var(--sp-3);
}
.usageMonth { font-family: var(--font-mono); font-size: 12px; color: var(--color-text-muted); }
.usageOk   { font-family: var(--font-mono); font-size: 13px; color: var(--color-sky); }
.usageWarn { font-family: var(--font-mono); font-size: 13px; color: #f59e0b; }
.usageCrit { font-family: var(--font-mono); font-size: 13px; color: #f87171; }

.usageBarTrack {
  height: 6px;
  background: var(--color-border);
  border-radius: 3px;
  overflow: hidden;
}
.usageBarFill {
  height: 100%;
  background: var(--color-sky);
  border-radius: 3px;
  transition: width 0.4s ease;
}
.usageBarWarn { background: #f59e0b; }
.usageBarCrit { background: #f87171; }

.usageMeta { display: flex; align-items: center; gap: var(--sp-3); margin-top: var(--sp-2); }
.usageMetaText { font-family: var(--font-mono); font-size: 11px; color: var(--color-text-faint); }
.usageWarnBadge {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  padding: 2px 7px; border-radius: 999px;
  background: rgba(245,158,11,0.12); border: 1px solid rgba(245,158,11,0.3); color: #f59e0b;
}
.usageCritBadge {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  padding: 2px 7px; border-radius: 999px;
  background: rgba(248,113,113,0.12); border: 1px solid rgba(248,113,113,0.3); color: #f87171;
}

.usagePrev { margin-top: var(--sp-4); padding-top: var(--sp-4); border-top: 1px solid var(--color-border); }
.usagePrevLabel { font-family: var(--font-mono); font-size: 11px; color: var(--color-text-faint); }

/* ── Delete org modal ──────────────────────────────────────── */
.modalOverlay {
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(0,0,0,0.6); backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center;
}
.modalBox {
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-lg);
  padding: var(--sp-6);
  width: 420px;
  box-shadow: 0 24px 64px rgba(0,0,0,0.5);
}
.modalTitle {
  font-family: var(--font-mono); font-size: 15px; font-weight: 700;
  color: #f87171; margin-bottom: var(--sp-4);
}
.modalBody { font-size: 13px; color: var(--color-text-muted); margin-bottom: var(--sp-3); line-height: 1.6; }
.modalInput {
  width: 100%; padding: 8px 12px;
  background: var(--color-bg); border: 1px solid var(--color-border-med);
  border-radius: var(--radius-sm); color: var(--color-text);
  font-family: var(--font-mono); font-size: 13px;
  margin-bottom: var(--sp-4);
  box-sizing: border-box;
}
.modalInput:focus { outline: none; border-color: #f87171; }
.modalActions { display: flex; gap: var(--sp-3); justify-content: flex-end; }
.modalCancel {
  font-family: var(--font-mono); font-size: 12px; font-weight: 600;
  padding: 7px 16px; border-radius: var(--radius-sm);
  background: transparent; border: 1px solid var(--color-border-med);
  color: var(--color-text-muted); cursor: pointer;
}
.modalCancel:hover { border-color: var(--color-border-strong); color: var(--color-text); }
.modalDelete {
  font-family: var(--font-mono); font-size: 12px; font-weight: 600;
  padding: 7px 16px; border-radius: var(--radius-sm);
  background: rgba(248,113,113,0.12); border: 1px solid rgba(248,113,113,0.3);
  color: #f87171; cursor: pointer; transition: background 0.12s;
}
.modalDelete:hover:not(:disabled) { background: rgba(248,113,113,0.2); }
.modalDelete:disabled { opacity: 0.4; cursor: not-allowed; }

.limitErr { font-size: 12px; color: var(--color-error); }

/* ── Billing tab ──────────────────────────────────────────── */
.billingTab { display: flex; flex-direction: column; gap: var(--sp-6); }

.billingNoPlan {
  padding: var(--sp-5) 0;
}
.billingNoPlanTitle {
  font-family: var(--font-mono);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: var(--sp-2);
}
.billingNoPlanSub {
  font-size: 13px;
  color: var(--color-text-muted);
  max-width: 480px;
  line-height: 1.6;
}

.billingActions {
  display: flex;
  align-items: center;
  gap: var(--sp-4);
}
